<template>
  <div class="signin">
    <div class="signin_content">
      <div class="signin_card">
        <div class="card_top">
          <h1>{{ $t('登录') }}</h1>
          <SignTab :active.sync="active" />
          <el-form :model="dataList" :rules="rules" ref="ruleFormRef">
            <el-form-item
              :key="active"
              :rules="[
                {
                  required: true,
                  message:
                    active === 0 ? $t('请输入手机号码') : $t('请输入邮箱地址'),
                  trigger: 'blur'
                }
              ]"
              prop="account"
              :class="{ mobileFormItem: active === 0 }"
            >
              <div class="information_item account-box">
                <div class="input_box">
                  <InternationalCode
                    v-if="active === 0"
                    containerWidth="100px"
                    isCountryDialCode
                    @selectCountry="onSelectCountry"
                  ></InternationalCode>
                  <el-input
                    v-model="dataList.account"
                    :placeholder="
                      active === 0 ? $t('手机号码') : $t('请输入邮箱地址')
                    "
                    :class="{ 'mobile-input': active === 0 }"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <div class="information_item password_item">
                <p class="tips">{{ $t('密码') }}</p>
                <div class="input_box">
                  <el-input
                    type="password"
                    v-model="dataList.password"
                    :placeholder="$t('请输入密码')"
                  />
                </div>
                <p class="forget_text">
                  <span class="is_link" @click="jumpTo('/forgetPassword')"
                    >{{ $t('忘记密码') }}？</span
                  >
                </p>
              </div>
            </el-form-item>
          </el-form>

          <div class="button_box">
            <el-button
              :loading="signInLoading"
              type="primary"
              @click="handleLogin()"
            >
              {{ $t('登录') }}
            </el-button>
          </div>
        </div>
        <div class="card_tips">
          <p @click="jumpTo('/register')">
            <span>{{ $t('没有账号') }}？ {{ $t('立即注册') }}</span>
            <img src="./../../assets/images/arrowLeft.png" alt="" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SignTab from './components/SignTab'
import InternationalCode from '@/components/internationalCode/index.vue'
import {
  SET_TOKEN,
  SET_USER_NAME,
  SET_MEMBER_NUMBER,
  SET_USER_INFO
} from '@/store/mutation-types'
import { userSignIn, fetchUserInfo } from '@/api/sign'

export default {
  components: {
    SignTab,
    InternationalCode
  },
  data() {
    return {
      active: 0,
      signInLoading: false,
      rules: {
        password: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' }
        ]
      },
      dataList: {
        account: '',
        password: '',
        areaCode: ''
      }
    }
  },
  watch: {
    active(newV) {
      if (newV) {
        this.dataList.areaCode = ''
      }
      this.$refs.ruleFormRef.resetFields()
    }
  },
  methods: {
    onSelectCountry(country) {
      this.dataList.areaCode = country.areaCode
    },
    jumpTo(path) {
      this.$router.push({ path: path })
    },
    async handleLogin() {
      await this.$refs.ruleFormRef.validate()
      this.signInLoading = true
      const { token } = await userSignIn(this.dataList).finally(() => {
        this.signInLoading = false
      })

      this.$store.commit(SET_TOKEN, token)
      try {
        const userInfo = await fetchUserInfo()
        this.$store.commit(SET_USER_INFO, userInfo)
        this.$store.commit(SET_MEMBER_NUMBER, userInfo.userId)
        this.$store.commit(SET_USER_NAME, userInfo.account)
        this.$router.replace({ path: '/' })
      } catch {
        this.$store.commit(SET_TOKEN, '')
      } finally {
        this.signInLoading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.signin {
  min-height: 685px;
  height: calc(100vh - 60px);
  background: rgba(19, 22, 37, 1);
  .signin_content {
    overflow: hidden;
    .signin_card {
      margin-top: 130px;

      /deep/ .el-form {
        .el-form-item {
          margin-bottom: 20px;
        }
        // 动态控制警告提醒位置（第一个 form-item）
        .mobileFormItem {
          .el-form-item__content {
            .el-form-item__error {
              left: 110px;
            }
          }
        }
      }

      .card_top {
        margin: 0 auto;
        padding: 38px 40px 40px;
        width: 420px;
        background: rgba(255, 255, 255, 1);
        border-radius: 20px;
        /deep/ .el-form {
          .el-form-item {
            margin-bottom: 20px;
          }
        }
        .tabs_box {
          margin-top: 40px;
        }
        h1 {
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 42px;
        }
        .information_item {
          .tips {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          /deep/ .input_box {
            margin-top: 10px;
            .element_input_mixin();
          }

          &.account-box {
            margin-top: 26px;
            .input_box {
              margin-top: 0;
              display: flex;
              .mobile-input {
                margin-left: 10px;
              }
            }
          }
        }
        .password_item {
          margin-top: 0px;
          position: relative;
          .forget_text {
            position: absolute;
            top: 80px;
            right: 0px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            text-align: right;
            line-height: 20px;
          }
        }
        .button_box {
          margin-top: 60px;
          .element_button_mixin(
            @padding: 12px 28px,
            @width: 100%,
            @fontSize: 18px,
            @borderRadius: 2px,
            @lineHeight: 24px
          );
        }
      }
      .card_tips {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        p {
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>
